import React, { useContext } from 'react'
import Logo from 'components/Gui/Logo';
import { ConfigContext } from 'contexts/ConfigContext';
import { HeaderWrapper } from './NwHeaderUI';

const NwHomeHeader = () => {
    const { clientConfig } = useContext(ConfigContext)
    const { header } = clientConfig

    return (
        <HeaderWrapper>
            <div className="header-left">
                <Logo />
            </div>
            <div className="header-middle">
                {header && header.htmlContent
                    ?
                    <div  className="header-html-content" dangerouslySetInnerHTML={{ __html: header.htmlContent }} />
                    :
                    <p></p>
                }
            </div>
            <div className="header-right">
            </div>
        </HeaderWrapper>
    )
}

export default NwHomeHeader

